import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function IndustriaList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Industrias';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="icono"
          render={(record: any) => (
            <img
              src={record.icono.url}
              alt={record.icono.alternativeText}
              style={{ width: '80px', height: 'auto' }}
            />
          )}
        />
        <TextField source="nombre" />
      </Datagrid>
    </List>
  )
}

export default IndustriaList;